import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {createSelector} from "reselect";

// Components
import AppToaster from "../common/components/toaster";

// Actions
import {deleteNotification, markNotificationAsShown} from "../notifications/notifications-actions";

// Selectors
import {notificationsSelector} from "../notifications/notifications-selector";

// Hooks
import Header from "../header/header";

// Component selector
const appLayoutPageSelector = createSelector(
    notificationsSelector,
    (notifications) => {
        return {
            notifications
        }
    }
);

// Redux dispatch hook
const useReduxDispatch = () => {
    const dispatch = useDispatch();
    return {
        markNotificationAsShown: (notificationId) => dispatch(markNotificationAsShown(notificationId)),
        deleteNotification: (notificationId) => dispatch(deleteNotification(notificationId))
    }
}

const AppLayout = (props) => {

    // Redux
    const {
        notifications,
    } = useSelector(state => appLayoutPageSelector(state));
    const {markNotificationAsShown, deleteNotification} = useReduxDispatch();

    // Notifications
    useEffect(() => {
        if (notifications && notifications.size > 0) {
            notifications.forEach(notification => {
                const notificationId = notification.get('notificationId');
                if (!notification.get('shown')) {

                    // onDismiss is a function called when the notification closes. We use this to delete the notification from Redux store.
                    notification = notification.set('onDismiss', () => deleteNotification(notificationId));

                    // Show the notification in app toaster if not already shown
                    AppToaster.show(notification.toJS());

                    // Immediately mark the notification as shown
                    markNotificationAsShown(notificationId);
                }
            });
        }
    }, [notifications]);

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            height: "100vh"
        }}>
            <Header/>
            <div style={{
                flex: 1,
                padding: 30,
                display: "flex",
                flexDirection: "column"
            }}>
                {props.children}
            </div>
        </div>
    );
};

export default AppLayout;